<template>
  <div class="student">
    <div class="main-wrap">
      <div id="main-content">
        <div class="wrapper">
          <el-row style="background：#fff" :class="isFixed?'fixed-top':'head-top'">
            <h2 class="basic-title" v-if="!isFixed">面试统计</h2>
            <el-col :span="24" class="title-content">
              <div class="time-check" v-if="dictDate">
                <h3>学期名称</h3>
                <el-select v-model="custom_year" placeholder="请选择" @change="dictDateSelect">
                  <el-option
                    v-for="item in dictDate.year"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value"
                  ></el-option>
                </el-select>
                <el-select v-model="custom_month" placeholder="请选择" @change="dictDateSelect">
                  <el-option
                    v-for="item in dictDate.month"
                    :key="item.name"
                    :label="item.name"
                    :value="item.value"
                  ></el-option>
                </el-select>
                <el-button @click="resetData">重置筛选</el-button>
                <el-col :span="24" style>
                  <el-tag
                    v-for="(tag , index ) in dynamicTags"
                    :key="index"
                    closable
                    :disable-transitions="false"
                    @close="handleClose(tag)"
                  >{{ tag.val?tag.type + ' : ' + tag.val:'全部' }}</el-tag>
                </el-col>
              </div>
            </el-col>
          </el-row>
          <div class="interview-charts">
            <el-row class="charts-wrap charts-top">
              <el-col :span="16">
                <div class="content">
                  <h3 class="basic-title">户籍地</h3>
                  <div id="charts-address" class="charts-area"></div>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="content">
                  <h3 class="basic-title">学历占比</h3>
                  <div id="charts-education" class="charts-area"></div>
                </div>
              </el-col>
            </el-row>
            <el-row class="charts-wrap">
              <el-col :span="8">
                <div class="content">
                  <h3 class="basic-title">是否是艺术生</h3>
                  <div id="charts-pie0" class="charts-area"></div>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="content">
                  <h3 class="basic-title">是否是日语专业</h3>
                  <div id="charts-pie1" class="charts-area"></div>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="content">
                  <h3 class="basic-title">是否有日语成绩</h3>
                  <div id="charts-pie2" class="charts-area"></div>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="content">
                  <h3 class="basic-title">JLPT</h3>
                  <div id="charts-pie3" class="charts-area"></div>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="content">
                  <h3 class="basic-title">NAT-TEST</h3>
                  <div id="charts-pie4" class="charts-area"></div>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="content">
                  <h3 class="basic-title">J-TEST</h3>
                  <div id="charts-pie5" class="charts-area"></div>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="content">
                  <h3 class="basic-title">STBJ</h3>
                  <div id="charts-pie6" class="charts-area"></div>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="content">
                  <h3 class="basic-title">年龄</h3>
                  <div id="charts-pie7" class="charts-area"></div>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="content">
                  <h3 class="basic-title">出生年份</h3>
                  <div id="charts-pie8" class="charts-area"></div>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="content">
                  <h3 class="basic-title">毕业年限</h3>
                  <div id="charts-pie9" class="charts-area"></div>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import echarts from 'echarts';
import { Loading } from 'element-ui';

export default {
  data() {
    return {
      fullscreenLoading: true,
      dictDate: {
        year: null,
        month: null
      },
      defaultDict: null,
      dynamicTags: [{ type: '全部' }],
      custom_year: '',
      custom_month: '',
      chartsAddress: null,
      chartsEducation: null,
      chartsPie: [null, null, null, null, null, null, null, null, null, null],
      pieName: [
        '是否是艺术生',
        '是否是日语专业',
        '是否有日语成绩',
        '日语能力考分布',
        'NAT-TEST',
        'J-TEST',
        'STBJ',
        '年龄',
        '出生年份',
        '毕业年限'
      ],
      picDict: [
        'art_exam',
        'japanese_major',
        'is_pass_exam',
        'jlpt_level',
        'nat_level',
        'jtest_level',
        'stbj_level',
        'write_age',
        'brith_year',
        'graduation_years'
      ],
      pieNameDict: {
        art_exam: '是否是艺术生',
        japanese_major: '是否是日语专业',
        is_pass_exam: '是否有日语成绩',
        jlpt_level: '日语能力考分布',
        nat_level: 'NAT-TEST',
        jtest_level: 'J-TEST',
        stbj_level: 'STBJ',
        write_age: '年龄',
        brith_year: '出生年份',
        graduation_years: '毕业年限'
      },
      chartsColor: [
        ['#88e7e8', '#48abff'],
        ['#48abff', '#6eff8d'],
        ['#88e7e8', '#48abff'],
        ['#ffd543', '#88e7e8', '#50afff'],
        ['#6eff8d', '#72d4d5', '#ffd543', '#48abff'],
        ['#87dbdc', '#ff8b2e', '#ffe42b', '#6eff8d', '#59b3ff'],
        ['#ffe42b', '#88e7e8'],
        ['#3fbef3', '#6eff8d', '#ffd543'],
        ['#3fbef3', '#88e7e8', '#f3e43f', '#ff8b2e'],
        ['#88e7e8', '#ff8b2e', '#f3e43f', '#6eff8d', '#59b3ff']
      ],
      place_area_data: null,
      education_data: null,
      pieData: null,
      postData: null,
      selectedAll: {},
      selectedState: [],
      barSelected: null,
      educationSelected: {},
      addressOptionData: null,
      educationOptionData: null,
      pieBindState: [
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false
      ],
      sunBindState: false,
      eduOptionData: null,
      addressClick: true,
      isFixed: null,
      tagNameArr: [],
    };
  },
  components: {
    echarts
  },
  methods: {
    handleClose(tag) {
      // console.log(tag);
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
      let selectType = null;
      let selected = null;
      let index = null;
      switch (tag.type) {
        case '户籍地':
          this.barSelected[tag.val] = false;
          selected = this.barSelected;
          selectType = 'custom_place_area';
          break;
        case '学历占比':
          this.educationSelected[tag.val] = false;
          selected = this.educationSelected;
          selectType = 'education';
          break;
        default:
          index = this.pieName.indexOf(tag.type);
          this.selectedState[this.picDict[index]][tag.val] = false;
          selected = this.selectedState[this.picDict[index]];
          selectType = this.picDict[index];
      }
      this.selectParams(selectType, selected, index);
    },
    // 户籍地图表
    initAddress: function() {
      this.chartsAddress = echarts.init(document.getElementById('charts-address'));
      this.chartsAddress.clear();
      let that = this;
      let colors = [];
      let defaultcolor = '#88dbdc';
      let selectedcolor = '#48abff';
      for (let i = 0; i < this.place_area_data.column.length; i++) {
        colors.push('#88dbdc');
      }
      const optionData = {
        xAxis: {
          type: 'category',
          data: this.place_area_data.column,
          nameTextStyle: {
            verticalAlign: 'top'
          },
          axisLabel: {
            interval: 0,
            rotate: 60,
            height: 200
          }
        },
        yAxis: {
          type: 'value'
        },
        grid: {
          x: 40,
          x2: 100,
          y2: 95
        },
        tooltip: {
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        series: [
          {
            data: this.place_area_data.data,
            type: 'bar',
            animation: false,
            label: {
              normal: {
                show: true,
                position: 'top',
                formatter: (data) => {
                  let dataAll = 0;
                  this.place_area_data.data.forEach((item) => {
                    dataAll += item;
                  });
                  return `${((data.data / dataAll) * 100).toFixed(2)}%`;
                }
              }
            },
            itemStyle: {
              color: function(params) {
                if (that.barSelected) {
                  colors = [];
                  let updateSelected = [];
                  that.place_area_data.column.forEach((item) => {
                    let barSelectKeyArr = Object.keys(that.barSelected);
                    let barSelectValueArr = Object.values(that.barSelected);
                    for (let i = 0; i < barSelectKeyArr.length; i++) {
                      if (barSelectKeyArr[i] === item) {
                        updateSelected.push(barSelectValueArr[i]);
                      }
                    }
                  });
                  for (
                    let index = 0;
                    index < updateSelected.length;
                    index++
                  ) {
                    updateSelected[index]
                      ? colors.push(selectedcolor)
                      : colors.push(defaultcolor);
                  }
                } else {
                  for (
                    let index = 0;
                    index < that.place_area_data.column.length;
                    index++
                  ) {
                    colors.push(defaultcolor);
                  }
                }
                return colors[params.dataIndex];
              }
            }
          }
        ]
      };
      this.addressOptionData = optionData;
      this.chartsAddress.setOption(optionData);
      if (this.addressClick) {
        this.chartsAddress.on('click', (params) => {
          if (that.barSelected) {
            let selectedArr = Object.keys(that.barSelected);
            let barSelectedVal = {};
            for (let i = 0; i < this.place_area_data.column.length; i++) {
              barSelectedVal[this.place_area_data.column[i]] = false;
              if (that.barSelected[selectedArr[i]]) {
                barSelectedVal[this.place_area_data.column[i]] = true;
              }
            }
            that.barSelected = barSelectedVal;
            let barSelectedArr = Object.keys(that.barSelected);
            for (let i = 0; i < barSelectedArr.length; i++) {
              if (params.name === barSelectedArr[i]) {
                that.barSelected[barSelectedArr[i]] = !that.barSelected[
                  barSelectedArr[i]
                ];
              }
            }
          } else {
            that.barSelected = {};
            for (let i = 0; i < this.place_area_data.column.length; i++) {
              that.barSelected[this.place_area_data.column[i]] = false;
            }
            that.barSelected[params.name] = true;
          }
          that.chartsAddress.clear();
          that.chartsAddress.setOption(this.addressOptionData);
          that.selectParams('custom_place_area', that.barSelected);
        });
        this.addressClick = false;
      }
    },
    // 学历分布图表
    initEducation: function() {
      let data = this.education_data.data;
      this.eduSelectData(data);
      this.eduShowData();
      if (!this.sunBindState) {
        this.chartsEducation.on('click', (params) => {
          this.educationSelected[params.name] = !this.educationSelected[
            params.name
          ];
          // }
          this.selectParams('education', this.educationSelected);
        });
        this.sunBindState = true;
      }
    },
    initPieCharts: function(item, index) {
      let tdata = this.picDict;
      let seriesType = tdata[index];
      let data = {};
      if (seriesType) {
        data = this.pieData[seriesType];
      }
      item = echarts.init(document.getElementById(`charts-pie${index}`));
      if (!data.data) {
        item.clear();
        return;
      }
      let keysArr = Object.keys(this.defaultDict);
      let valuesArr = Object.values(this.defaultDict);
      let Arr = [];
      let pieVal = [];
      valuesArr.forEach((item, i) => {
        let dictkeysArr = Object.keys(item);
        Arr.push({
          keys: keysArr[i],
          values: dictkeysArr
        });
      });
      let dictArr = null;
      Arr.forEach((item) => {
        if (seriesType === item.keys) {
          dictArr = item.values;
        }
      });
      dictArr.forEach((item) => {
        data.data.forEach((z) => {
          if (item === z.name) {
            pieVal.push({
              name: item,
              value: z.value,
              proportion: z.proportion
            });
          }
        });
      });
      item.clear();
      const option = {
        color: this.chartsColor[index],
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c} ({d}%)'
        },
        legend: {
          orient: 'horizontal',
          left: 'center',
          formatter: (name) => {
            let target;

            for (let i = 0, l = pieVal.length; i < l; i++) {
              if (pieVal[i].name === name) {
                target = pieVal[i].proportion;
              }
            }
            let arr = [`${name} : ${target}`];
            return arr;
          }
        },
        series: [
          {
            name: this.pieName[index],
            type: 'pie',
            hoverAnimation: false,
            selectedMode: 'multiple',
            selectedOffset: 20,
            radius: '65%',
            center: ['50%', '55%'],
            data: pieVal,
            animation: false,
            itemStyle: {
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      };

      item.setOption(option);
      if (!this.pieBindState[index]) {
        item.on('pieselectchanged', (params) => {
          this.selectParams(seriesType, params.selected, index);
        });
        this.pieBindState[index] = true;
      }
      if (this.selectedState[seriesType]) {
        let arrValue = Object.values(this.selectedState[seriesType]);
        let arrKeys = Object.keys(this.selectedState[seriesType]);
        for (let i = 0; i < arrValue.length; i++) {
          if (arrValue[i]) {
            item.dispatchAction({
              type: 'pieSelect',
              seriesIndex: 0,
              name: arrKeys[i]
            });
          }
        }
      }
    },
    makePieCharts: function() {
      this.chartsPie.forEach((item, index) => {
        this.initPieCharts(item, index);
      });
    },
    getData() {
      this.$http
        ._post({ url: '/index/b_i_interview_form/getData' })
        .then(({ data }) => {
          this.pieData = data;
          this.place_area_data = data.custom_place_area;
          this.education_data = data.education;
          this.dictDate.year = data.custom_year;
          this.dictDate.month = data.custom_month;
          // 生成户籍地
          this.initAddress();
          // 生成学历占比
          this.initEducation();
          // 生成饼图
          this.makePieCharts();
        });
    },
    dictDateSelect() {
      this.selectedAll.year = this.custom_year;
      this.selectedAll.month = this.custom_month;
      this.updateData();
    },
    selectParams(type, selected) {
      let typeDict = this.defaultDict[type];
      let typeArr = [];
      this.dynamicTags = [];
      let arrValue = Object.values(selected);
      let arrKey = Object.keys(selected);
      for (let i = 0; i < arrValue.length; i++) {
        if (arrValue[i]) {
          // console.log(arrKey[i].split(' \n ')[0]);
          let name = arrKey[i].split(' \n ')[0];
          if (typeDict[name].length === 1) {
            typeArr.push(typeDict[name][0]);
          } else {
            typeDict[name].forEach((item) => {
              typeArr.push(item);
            });
          }
        }
      }
      this.selectedState[type] = selected;
      this.selectedAll[type] = typeArr;
      let selectedStateValue = Object.values(this.selectedState);
      let selectedStateKey = Object.keys(this.selectedState);
      selectedStateKey.forEach((item, index) => {
        let selectedStateChildValue = Object.values(selectedStateValue[index]);
        let selectedStateChildkey = Object.keys(selectedStateValue[index]);
        selectedStateChildValue.forEach((e, i) => {
          if (e) {
            this.dynamicTags.push({
              type: this.topShowData(item),
              val: selectedStateChildkey[i], //
            });
          }
        });
      });
      // for (let i in this.selectedState) {
      //   for (let j in this.selectedState[i]) {
      //     if (this.selectedState[i][j]) {
      //       // console.log(i);
      //       this.dynamicTags.push({
      //         type: this.topShowData(i),
      //         val: j, //
      //       });
      //     }
      //   }
      // }
      this.updateData();
    },
    topShowData: function(type) {
      let place = null;
      switch (type) {
        case 'custom_place_area':
          place = '户籍地';
          break;
        case 'education':
          place = '学历占比';
          break;
        default:
          place = this.pieNameDict[type];
      }
      return place;
    },
    eduSelectData(obj) {
      console.log(obj);
      let objKeys = Object.values(obj);
      for (let i = 0; i < objKeys.length; i++) {
        if (objKeys[i] === 'name') {
          this.educationSelected[obj[objKeys[i]]] = false;
        }
        if (typeof obj[objKeys[i]] === 'object') {
          this.eduSelectData(obj[objKeys[i]]);
        }
      }
      // for (let i of obj) {
      //   if (i === 'name') {
      //     this.educationSelected[obj[i]] = false;
      //   }

      // }
    },
    eduInitData(data, i) {
      if (!data) {
        return;
      }
      if (i > 4) {
        return;
      }
      i++;
      let lengthi = data.length;
      for (let j = 0; j < lengthi; j++) {
        let name0 = data[j].name;
        data[j].name = `${name0} \n ${data[j].proportion}`;
        if (this.educationSelected[name0]) {
          // 选中样式添加
          data[j].itemStyle = {
            borderColor: '#000'
          };
        } else {
          data[j].itemStyle = {
            borderColor: '#fff'
          };
        }
        if (data[j].children) {
          this.eduInitData(data[j].children, i);
        }
      }
    },
    eduShowData() {
      let data = this.education_data.data;
      this.chartsEducation = echarts.init(document.getElementById('charts-education'));
      this.chartsEducation.clear();
      // if (!this.sunBindState) {
      this.eduInitData(data, 0);
      // }
      let maxnum = this.education_data.max;
      let minnum = this.education_data.min;
      const option = {
        visualMap: {
          type: 'continuous',
          min: minnum,
          max: maxnum,
          inRange: {
            color: [
              '#257BCE',
              '#257CCC',
              '#3BBE54',
              '#F4CE11',
              '#FF7F28',
              '#FF4366',
              '#C76DDF',
              '#9B31B7',
              '#C95D75'
            ]
          }
        },
        tooltip: {
          trigger: 'item',
          formatter: '{b} : {c}'
        },
        silent: false,
        series: {
          type: 'sunburst',
          highlightPolicy: 'self',
          nodeClick: false,
          data: data,
          radius: [0, '80%'],
          center: ['50%', '54%'],
          animation: false,
          label: {
            rotate: 'radial'
          },
          itemStyle: {
            emphasis: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          }
        }
      };
      this.eduOptionData = option;
      this.chartsEducation.setOption(option);
    },
    resetData() {
      this.selectedAll = {};
      this.barSelected = null;
      this.educationSelected = {};
      this.selectedState = [];
      this.dynamicTags = ['全部'];
      this.custom_year = 0;
      this.custom_month = 0;
      let reset = true;
      // location.reload();
      this.updateData(reset);
    },
    updateData() {
      let option = {
        lock: true,
        text: '加载中'
      };
      let loadingInstance = Loading.service(option);
      this.$http
        ._post({
          url: '/index/b_i_interview_form/getData',
          data: this.selectedAll
        })
        .then(({ data }) => {
          this.pieData = data;
          this.dictDate.year = data.custom_year;
          this.dictDate.month = data.custom_month;
          this.place_area_data = data.custom_place_area;
          this.education_data = data.education;
          // 生成户籍地
          this.initAddress();
          // 生成学历占比
          this.education_data.length !== 0
            ? this.initEducation()
            : this.chartsEducation.clear();
          // 生成饼图
          this.makePieCharts();
          // 关闭loading
          loadingInstance.close();
        });
      // this.$http._post({

      // })
    },
    handleScroll() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (scrollTop > 120) {
        this.isFixed = true;
      } else {
        this.isFixed = false;
      }
    }
  },
  created() {
    this.$http
      ._post({ url: '/index/b_i_interview_form/getDict' })
      .then(({ data }) => {
        this.defaultDict = data.reDict;
      });
  },
  mounted() {
    this.getData();
    window.addEventListener('scroll', this.handleScroll);
  }
};
</script>

<style scoped>
.interview-charts {
  padding: 0 80px 60px;
  background-color: #d2d7d9;
  overflow: hidden;
}
.title-content {
  min-height: 90px;
}
.time-check .el-select {
  margin-left: 8px;
  margin-right: 10px;
}
.time-check h3 {
  display: inline-block;
  margin-left: 10px;
}
.charts-top {
  /* margin-top: 100px; */
}
.charts-wrap {
  /* margin-top: 40px; */
}
.charts-wrap > div {
  margin-bottom: 36px;
  padding-right: 36px;
}
.charts-wrap .content {
  width: 100%;
  height: 100%;
  padding: 20px;
  background: #fff;
  border-radius: 25px;
}
.charts-area {
  width: 100%;
  height: 500px;
}
.el-tag {
  margin-left: 10px;
  margin-top: 10px;
  background: #fff;
  cursor: pointer;
}
.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.head-top {
  padding: 0 80px;
  background: #d2d7d9;
}
.fixed-top {
  position: fixed;
  top: 80px;
  background: #fff !important;
  padding: 10px 20px;
  box-shadow: 5px 5px 5px #ccc;
  width: 100%;
  z-index: 99;
}
</style>
